
  import { defineComponent, inject } from "vue";

  import { helpers, required } from "@vuelidate/validators";
  import { get, isEmpty, set } from "lodash";

  import BaseProcessComponentV2 from "@/components/processComponents/v2/BaseProcessComponentV2.vue";
  import fileUpload from "@/mixins/fileUpload";
  import { acceptedFileTypes, requiredFile } from "@/helpers/fileUploadValidators";

  export default defineComponent({
    name: "FileUploadFormV2",

    extends: BaseProcessComponentV2,

    mixins: [fileUpload],

    setup(props: any) {
      const root: string = props.path.split(".")[0];

      return {
        [root]: inject(root),
      };
    },

    computed: {
      name: {
        get(): string | null {
          return this.value?.name ?? null;
        },
        set(newValue: string | null) {
          set(this, `${this.path}.name`, newValue);
        },
      },

      fileName(): string | null {
        if (this.file) {
          return this.file.name;
        }

        if (this.documentId) {
          return this.documentId.split("/").pop() || null;
        }

        return null;
      },

      validationState(): Record<string, any> {
        return {
          file: get(this.v$, `${this.path}.name`),
          name: get(this.v$, `${this.path}.name`),
        };
      },
    },

    methods: {
      async getFile(event: Event): Promise<void> {
        const { files } = event.target as HTMLInputElement;
        const file: File | null = get(files, "0", null);
        this.error = null;

        if (!file) {
          return;
        }

        this.error = await this.validateFile(file);

        if (this.error) {
          this.resetInput();
          return;
        }

        this.file = file;

        this.contentType = get(file, "type", null);
      },

      clear() {
        this.revokePreviewObjectUrl();
        this.file = null;
        this.error = null;
        this.contentType = null;
        this.documentId = null;
        this.resetInput();
        get(this.v$, this.path)?.$reset();
      },
    },

    validations() {
      const [root, ...rest] = this.path.split(".");
      const allowedMimeTypes: string[] = get(this.settings, "restrictions.allowedMimeTypes", []);

      const objectRules: any = {
        $autoDirty: true,
        requiredFile: helpers.withMessage("Este campo es requerido.", requiredFile()),
        name: {
          $autoDirty: true,
          required: helpers.withMessage("Este campo es requerido.", required),
        },
      };

      if (!isEmpty(allowedMimeTypes)) {
        objectRules.acceptedFileTypes = helpers.withMessage(
          "El tipo de archivo seleccionado es inválido.",
          acceptedFileTypes(allowedMimeTypes)
        );
      }

      const validations = {};
      set(validations, rest.join("."), objectRules);

      return {
        [root]: validations,
      };
    },
  });
